import { faSparkles } from '@fortawesome/pro-solid-svg-icons';

import { Body, Icon, Link, Tag, cn } from '@growtherapy/sprout-ui';

import { getAppConfig } from '../../config';
import { useTheme } from '../../hooks';
import { Theme } from '../../state';
import { useGetReadyAvsCountQuery } from './useGetReadyAvsCountQuery';

type AvsCtaPillProps = {
  numSummaries: number;
  className?: string;
};

const providerDashboardUri = `${getAppConfig().providerOrigin}/dashboard`;

export function AvsCtaPill({ numSummaries, className }: AvsCtaPillProps) {
  const { theme } = useTheme();
  if (!numSummaries) return;

  const sessionSummaryText =
    numSummaries === 1 ? 'session insights summary is available' : 'session insights summaries are available';

  return (
    <Tag
      data-testid='avs-cta-pill'
      use='neutral'
      aria-label='Session insights summaries are available in your portal'
      className={cn(
        'normal-case bg-neutral-900 gap-2 w-fit flex items-center',
        {
          'rebrand:bg-surface-inverseEmphasis arc:bg-surface-inverseEmphasis': theme === Theme.DARK,
        },
        className,
      )}
    >
      <Icon aria-hidden className='text-lilac-400 rebrand:text-text-inverse' icon={faSparkles} />
      <Body.Small as='span' className='text-neutral-100 rebrand:text-text-inverse'>
        {numSummaries} {sessionSummaryText} in
      </Body.Small>{' '}
      <Link
        className='text-neutral-100 text-sm rebrand:text-action-primary-textLinkInverse rebrand:hover:text-action-primary-textLinkInverseHover'
        href={providerDashboardUri}
        external
        size='sm'
      >
        your portal
      </Link>
    </Tag>
  );
}

export function AvsCtaPillWrapper(props: Pick<AvsCtaPillProps, 'className'>) {
  const { data, loading } = useGetReadyAvsCountQuery();
  const numSummaries = data?.afterVisitSummariesReady?.totalReadyForReview ?? 0;

  if (loading) return;

  return <AvsCtaPill {...props} numSummaries={numSummaries} />;
}
